import React, { Component } from "react"
import { Container, Modal, Spinner } from "react-bootstrap"

export interface ProcessingModalProps {
  message: string
}
export default class ProcessingModal extends Component<ProcessingModalProps> {
  render() {
    return (
      <Modal backdrop="static" show size="sm" dialogClassName="loading" centered>
        <Modal.Body>
          <Container fluid>
            <div className="text-center">
              <Spinner animation="border" variant="light" />
              <p>{this.props.message}</p>
            </div>
          </Container>
        </Modal.Body>
      </Modal>)
  }
}
